import { retrieveIncidentTypeCategoriesV2 } from "@/lib/data/requests";
import { queryKeys } from "@/lib/data/static";

export const retrieveIncidentTypeCategoriesQueryOptions = () => ({
  queryKey: [queryKeys.incidentTypeCategories],
  queryFn: () => retrieveIncidentTypeCategoriesV2(),
});
